import * as React from "react";
import { Icon, Collapse } from "@focus/focusUI";
import { ErrorListItem } from "./ErrorListItem";
import "./ErrorList.scss";
export const ErrorList = ({ uiSchema, errorSet, onErrorClick, }) => {
    const [isListOpen, setIsListOpen] = React.useState(false);
    const orderComponentErrors = (fieldName, uiSchema, errors) => {
        let orderedErrors = [];
        let order = uiSchema["ui:order"];
        if (typeof errors !== "undefined") {
            orderedErrors = errors.errors.map((error) => ({
                source: fieldName,
                error,
            }));
            if (typeof order !== "undefined") {
                for (let i = 0; i < order.length; i++) {
                    const component = order[i];
                    orderedErrors = orderedErrors.concat(orderComponentErrors(component, uiSchema[component], errors[component]));
                }
            }
        }
        return orderedErrors;
    };
    const orderErrors = () => {
        let orderedErrors = [];
        let order = uiSchema["ui:order"];
        for (let i = 0; i < order.length; i++) {
            const component = order[i];
            orderedErrors = orderedErrors.concat(orderComponentErrors(component, uiSchema[component], errorSet[component]));
        }
        return orderedErrors;
    };
    const handleClick = (source, error) => {
        onErrorClick(source, error);
    };
    const orderedErrors = orderErrors();
    const errorList = orderedErrors.map((errorObject, i) => (React.createElement(ErrorListItem, { key: errorObject.source + "_" + i, source: errorObject.source, error: errorObject.error, onErrorClick: handleClick })));
    return (React.createElement("div", { className: "error-panel", role: "errorlist" },
        React.createElement("div", { className: "error-title", onClick: () => setIsListOpen(!isListOpen) },
            React.createElement("h3", { className: "error-title-text panel-title" },
                React.createElement(Icon, { className: "error-icon", icon: isListOpen ? "chevron-up" : "chevron-down" }),
                "Errors")),
        React.createElement(Collapse, { isOpen: isListOpen, keepChildrenMounted: true },
            React.createElement("ul", { className: "list-group" }, errorList))));
};
//# sourceMappingURL=ErrorList.js.map